<template>
	<div id="app">
		<keep-alive exclude="newsDetail,exchangeDetail,productDooryardDetail">
			<router-view v-if="isRouterAlive" />
		</keep-alive>
	</div>
</template>
<script>
	import utils from '@/common/utils'
	import wxsdk from '@/common/wxsdk'
	export default {
		name: 'app',
		provide() { // 注册一个方法
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		methods: {
			reload() {
				this.isRouterAlive = false
				this.$nextTick(function() {
					this.isRouterAlive = true;
				})
			},
			// registerWxConfig() {
			// 	if (window.location.href.indexOf('poster') > -1) {
			// 		if (isWeixin()) {
			// 			wx.miniProgram.getEnv((res) => {
			// 				if (res.miniprogram) {
			// 					console.log('在小程序内');
			// 				} else {
			// 					console.log('不在小程序内');
			// 					wxConfig();
			// 				}
			// 			});
			// 		}
			// 	}
			// },
			// isWeixin() {
			// 	return /micromessenger/i.test(window.navigator.userAgent);
			// }
		},
		created() {
			if (!utils._isMobile()) {
				window.location.href = 'http://xiaoyuan.com.cn' + window.location.pathname + window.location.search
			}
		},
		// mounted() {
		// 	this.registerWxConfig();
		// }
	}
</script>
<style lang="scss">
	@import './common/css/base.css';
	@import './common/css/iconfont.css';
	@import './common/css/iconfont_program.css';
	@import './common/css/animate.min.css';

	.content {
		img {
			display: block;
			width: 100%;
		}
	}
</style>